import * as React from "react";
import { withRouter } from 'react-router'
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";
import NavigateParent from "./navigateParent";

class TestComponentError extends React.Component {

    constructor(props) {
        super(props);
        //let sTest = window.location.href;
    }

    render() {
        throw new Error("Totally blow out with an error!");
        //let sTest = window.location.href;
        const iframeResizerOptions = { checkOrigin: false, minHeight: 1400, scrolling: true, heightCalculationMethod: 'bodyScroll' };
        const iframeResizerStyle = { width: '100%' };
        const noLinks = { minHeight: '1400px', height: '100%' };
        return (
            <div style={noLinks} className="mychartDataTile">
                Hello.  Our pre-render should have blow up here.  :)
            </div>);
    }
}


export default TestComponentError;